<ng-container *transloco="let t; read: 'configuration'">
<div class="p-5">
  <div class="flex flex-row">
    <div class="basis-1/2">
      <drdp-title [title]="t('sites.title')"></drdp-title>
    </div>
    <div class="basis-1/2">
      <div class="flex justify-end items-end">
        <drdp-btn *drdpCheckPermission="Permission.CreateSites" (click)="openModal()">
          <i class="uil uil-plus"></i>
          {{ t('sites.addNew') }}
        </drdp-btn>
      </div>
    </div>
  </div>
  <drdp-container>
    <drdp-search
      (search)="searchSite($event)"
      (clear)="onClear()"
      [searchInput]="searchInput"
      [reload]="reload"
      [textInputPlaceholder]="t('sites.fields.siteName')">
    </drdp-search>
    <div class="p-5 w-full">
      <drdp-add-edit-table
        class="whitespace-pre-wrap"
        [dataSource]="dataSource"
        [tableData]="tableData"
        [columns]="tableColumns" 
        [isSuperAdmin]="hasAccessToAll"
        (editActionItem)="openModal($event)"
        (toggleSwitchActionItem)="changeActiveStatus($event)"
        (deleteActionItem)="deleteModal($event)"
        [toggleMsg]="t('sites.deactivateConfirm')">
      </drdp-add-edit-table>
    </div>
  </drdp-container>
  <mat-paginator
    [pageSizeOptions]="pageSizeOptions"
    [pageSize]="pageSize"
    [length]="totalData"
    [pageIndex]="pageIndex"
    (page)="paginate(false)">
  </mat-paginator>
</div>
</ng-container>
